import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IFooterLinksColumnProps } from '../components/footer/footer-links-column/footer-links-column';
import { FooterLinkModel } from './footer-link-model';
import { IFooterLinkProps } from '../components/footer/footer-link/footer-link';

export class FooterLinksColumnModel extends ContentItem {
  get columnTitle(): string {
    return get(this._config, 'elements.column_title.value', '');
  }

  get links(): IFooterLinkProps[] {
    const links = get(this._config, 'elements.links.value', []);
    const modeledLink = links.map((link: IFooterLink) =>
      FooterLinkModel.create(link)
    );

    return modeledLink;
  }

  public static create(data: IFooterLinksColumn): IFooterLinksColumnProps {
    const { columnTitle, links } = new FooterLinksColumnModel(data);
    return {
      columnTitle,
      links
    };
  }
}
